import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { AddUsers } from "../../components/users/AddUsers.component";
export const UsersAddPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Users <BreadCrumbSign /> New
          </p>
          <AddUsers />
        </div>
      </div>
    </div>
  );
};
